export default "__VITE_ASSET___C5M47jk__"